import { Injectable } from '@angular/core';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Logger } from './../logger.service';
import { AvailibilityService } from './../services/availibility.service';
import { SiteInfosService } from './../services/site-infos.service';
import { ComparatorsService } from './../services/comparators.service';
import { WindowRefService } from './../window-ref.service';
import { Room } from './../models/room.model';
import { Ota, BestPrice, Recommandations, ItemRecommandation, BestRecommandation } from './../models/ota.model';
import { Availibility, AvailRoom } from './../models/availibility.model';
import { map as _map, find, minBy, forEach, orderBy, pickBy, pullAt, keys, groupBy, unionWith, filter, has, head, chain, first } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { IComparatorPush, ICombine, IChambre, IParamsSearch, ICombineEngine } from '@app/shared/interfaces';
import { Line } from './../models/line.model';
import { SearchDispo } from './../models/search-dispo.model';
import { Store } from '@ngrx/store';
import { OtaAddNew, OtaAddCombine } from '../../state/ota/app.actions-ota'
import { RoomSortingService, SearchCriteria } from './room-sorting.service';

const log = new Logger('SearchDispoService');

@Injectable({
    providedIn: 'root'
})
export class SearchDispoService {
    private firstLoadOta: boolean = false;// first ota loading with data
    private allOtaLoaded: boolean = false;// all ota is completed
    private lastSearchDispo: SearchDispo;// last  SearchDispo
    private aliasBookingBasic: string = "bb";
    private aliasBooking: string = "b";
    private aliasBackoffice: string = "so";
    rooms: Array<Room>;
    bestRates: Array<BestPrice>;
    searchRun: Array<Subscription> = [];
    stockHasDispo: boolean = false; //hasAvailibility
    errors: any = {};
    recommendation: Array<Recommandations> = [];
    private adults: number;
    private enfants: number;
    private currentAvailibility: Availibility|null = null;

    constructor(private siteInfosService: SiteInfosService, private comparatorsService: ComparatorsService, private availibilityService: AvailibilityService, private translate: TranslateService, private winRef: WindowRefService
        , private store: Store<any>
        , private readonly roomSortingService: RoomSortingService
    ) {
        this.rooms = this.siteInfosService.getChambre();
    }

    /**
     * run search dispo & comparators
     *
     * @param listOta Array<string> list ota e,b,a...
     * @param start string date start Y-m-d
     * @param end string date end Y-m-d
     * @param adults number nb adults
     * @param enfants number enfants
     * @param agesEnfants Array<int> agesEnfants
     * @param currency string currency
     * @returns SearchDispo
     */
    run(listOta: Array<string>, start: string, idetab: number, end: string, adults: number, enfants: number, agesEnfants: Array<any>, currency: string): SearchDispo {
        this.currentAvailibility = null;
        let searchDispo = new SearchDispo();
        this.bestRates = this.loadBestRates();
        this.firstLoadOta = false;
        this.allOtaLoaded = false;
        this.stockHasDispo = false;
        this.errors = {};
        this.recommendation = [];
        this.adults = adults;
        this.enfants = enfants;
        let paramsSearch: IParamsSearch = { start: start, end: end, adults: adults, enfants: enfants, agesEnfants: agesEnfants };
        searchDispo.setParamsSearch(paramsSearch);
        searchDispo.tokenSearch = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);
        //console.log('Search is run '.concat(searchDispo.tokenSearch));
        window.postMessage({ eventId: "eventSearchDispo", data: { start: start, end: end, adults: adults, enfants: enfants, idetab: idetab, currency: currency } }, "*");
        if (this.winRef.appConfigSite.device == "PC" && has(listOta, this.aliasBookingBasic)) {
            delete listOta[this.aliasBookingBasic];
        }
        searchDispo.dispo$ = this.availibilityService.getDisp(start, end, adults, enfants, idetab, agesEnfants, currency, searchDispo.tokenSearch, this.winRef.appConfigSite.utm_source).pipe(map((rep: Availibility) => {
            if (!(rep instanceof Availibility)) {
                for (let aliasEngine in listOta) {
                    let bestPrice: BestPrice = find(this.bestRates, { alias: aliasEngine });
                    bestPrice.loading = false;
                }
                return rep;
            }
            for (let r of this.rooms) {
                let room = rep.findRoom(r.id);
                if (room) {
                    r.bindingData(room);
                }
            }
            const currentAvailibility : Availibility = rep;
            //this._bestPriceByAvailibility(rep);
            for (let aliasEngine in listOta) {
                let o = this.comparatorsService.getOta(aliasEngine, start, idetab, end, adults, enfants, agesEnfants, currency, searchDispo.tokenSearch, this.winRef.appConfigSite.utm_source);
                searchDispo.otas.push(o.pipe(map((rep: Ota) => {
                    log.warn('alias:', aliasEngine)
                    let bestPrice: BestPrice = find(this.bestRates, { alias: aliasEngine });
                    bestPrice.loading = false;
                    if (rep) {
                        this.firstLoadOta = true;
                        this._bestPriceByOta(bestPrice, rep, currentAvailibility);

                        this.addBestRatePartner(aliasEngine, rep);
                        this.addBestRateGoogle(aliasEngine, rep);

                        _map(rep.engine, (engine, key) => {
                            let t = key.split('_');
                            let [idRoom, idLine, adult, child, index] = t;
                            let _occupation = adult + "_" + child
                            //, indexSearch = "".concat(_occupation, "_", index, '_', aliasEngine)
                            let room: Room = find(this.rooms, { id: parseInt(idRoom) });
                            if (room) {
                                //                                let line = room.findLineByIndex(idLine, indexSearch);
                                let line = room.findLineBy(idLine, _occupation);
                                if (line) {
                                    line.addEngine({ combine: engine, alias: aliasEngine }).enabled().updateMinEngine();
                                    this.store.dispatch(new OtaAddCombine({ combine: engine, alias: aliasEngine }));
                                } else {
                                    line = room.findLine(idLine);
                                    if (line) {
                                        let lineClone = line.clone();
                                        lineClone.clearEngine().setOccupation(_occupation).setIndexSearch(engine.indexSearch);
                                        lineClone.addEngine({ combine: engine, alias: aliasEngine }).enabled().updateMinEngine();
                                        this.store.dispatch(new OtaAddCombine({ combine: engine, alias: aliasEngine }));
                                        room.addLine(lineClone);
                                    } else {
                                        log.error('id rate '.concat(idLine, ' not found in room ', room.id.toString()))
                                    }
                                }
                            }
                            if (!!room && !!room.isUpgraded()) {
                                room.roomUpgrade = 1;
                            }

                        });
                        this.recommendation.push({ alias: aliasEngine, rooms: rep.rooms_recommended })
                        window.postMessage({ eventId: "eventBestPrice", data: this.eventBestPriceData() }, "*");
                        this.store.dispatch(new OtaAddNew(rep));
                        //                        this.store.dispatch({type: 'OTA.add.new', payload: {ota: rep}});
                    } else {
                        this.errors[aliasEngine] = this.comparatorsService.getErrors(aliasEngine);
                    }
                    this.orderByLine(adults, enfants)
                    //                    console.log(this.rooms)
                    return rep;
                })));
            }
            searchDispo.allComapartors$ = forkJoin(searchDispo.otas).pipe(map(o => {
                log.warn('all Otas is completed 0', o);
                o.forEach(value => {
                    if (value != null) {
                        this.stockHasDispo = true;
                    }
                });
                window.postMessage({ eventId: "eventAllIsCompleted", data: { start: start, end: end, adults: adults, currency: currency } }, "*");
                this.allOtaLoaded = true;
                return o;
            }));
            return rep;
        }));
        this.lastSearchDispo = searchDispo;
        return this.lastSearchDispo;
    }

    private orderByLine(adults: number, enfants: number) :void
    {
        const searchCriteria: SearchCriteria = {
            adults: this.winRef.appConfigSite.adults,
            children: this.winRef.appConfigSite.enfants
        };
        forEach(this.rooms, (value: Room) => {
            value.lines = this.roomSortingService.sortLines(value.lines, searchCriteria);
            let fierstLineDispo = value.lines.filter(o => o.isDispo);
            if (fierstLineDispo.length) {
                value['engineSelected'] = fierstLineDispo[0].engineSelected;
            } else {
                value['engineSelected'] = null;
            }
        });
        this.rooms = this.roomSortingService.sortRealRooms(this.rooms, searchCriteria);
    }

    /**
     * // TODO: remove function sort and changed by service this.roomSortingService
     */
    // private _orderByLine(adults: any, enfants: any) {
    //     forEach(this.rooms, (value: Room) => {
    //         value.lines = this.SortAndOrder(value.lines, adults, 'adults', enfants, 'enfants', 'engineSelected.combine.ttc', 'engineSelected.combine.room_upgrade');

    //         let fierstLineDispo = value.lines.filter(o => o.isDispo);
    //         if (fierstLineDispo.length) {
    //             value.orderAdults = fierstLineDispo[0].adults;
    //             value.orderEnfants = parseInt(fierstLineDispo[0].engineSelected.combine.child.toString());
    //             value.orderTtc = fierstLineDispo[0].engineSelected.combine.ttc;
    //         } else {
    //             value.orderAdults = -1;
    //             value.orderEnfants = -1;
    //             value.orderTtc = 99999999999;

    //         }
    //     });
    //     let groupedByStock = groupBy(this.rooms, function (r: Room) {
    //         return r.stock < 1 ? 'fail' : 'pass'
    //     });
    //     let roomsHasStock = this.SortAndOrder(groupedByStock.pass, adults, 'orderAdults', enfants, 'orderEnfants', 'orderTtc', 'roomUpgrade');
    //     let roomsNotStock = this.SortAndOrder(groupedByStock.fail, adults, 'orderAdults', enfants, 'orderEnfants', 'orderTtc', 'roomUpgrade');
    //     this.rooms = unionWith(roomsHasStock, roomsNotStock);
    // }

    /**
     * // TODO: remove function sort and changed by service this.roomSortingService
     */
    // private SortAndOrder(value, adults, pathorderAdults, enfants, pathOrderEnfants, orderTtc, roomUpgrade) {
    //     let res = orderBy(value, [pathorderAdults, pathOrderEnfants, orderTtc, roomUpgrade], ['desc', 'asc', 'asc', 'desc'])
    //     let pick = pickBy(res, { [pathorderAdults]: adults })
    //     let pulled = pullAt(res, keys(pick));
    //     let grouped = groupBy(res, function (n) {
    //         return n[pathorderAdults] < adults ? 'fail' : 'pass'
    //     });
    //     let pass = orderBy(grouped.pass, [pathorderAdults, orderTtc, roomUpgrade], ['asc', 'asc', 'desc'])

    //     let pickEnfants = pickBy(pulled, { [pathOrderEnfants]: enfants });
    //     let pulledEnfant = pullAt(pulled, keys(pickEnfants));
    //     let groupedEnfants = groupBy(pulled, function (n) {
    //         return n[pathOrderEnfants] < enfants ? 'fail' : 'pass'
    //     });
    //     let passEnfant = orderBy(groupedEnfants.pass, [pathOrderEnfants, orderTtc, roomUpgrade], ['asc', 'asc', 'desc'])

    //     return unionWith(pulledEnfant, passEnfant, groupedEnfants.fail, pulled, pass, grouped.fail)
    //     //return unionWith(pulled, pass, grouped.fail)
    // }


    /**
     * load romm with line from push
     */
    public addRoomWihtPush(data: IComparatorPush): void {
        log.warn('new push:', data);
        if (data.comparator) {
            let ota = this.comparatorsService.getDataOta(data.comparator.engine);
            if (ota) {
                if (data.comparator.start == ota.ds && data.comparator.end == ota.de && data.comparator.occupation == ota.bestprice['searchedby']) {
                    let regex = new RegExp(data.comparator.roomcode.toString().concat('_'), 'g')
                        , keysRoom: Array<string> = filter(keys(ota.engine), (v: string) => { return !!v.match(regex) })
                        , roomPush: Room = find(this.rooms, (r: Room) => { return r.id == data.comparator.idchambre }),
                        rBasic = this.availibilityService.getAvailibility().findRoom(this.siteInfosService.getChambreBasic().id)
                        ;

                    keysRoom.map((v: string) => {
                        let key = v.replace(data.comparator.roomcode, data.comparator.idchambre.toString()),
                            newCombine: ICombine = ota.engine[v];
                        ota.addEnginWithPush(key, ota.engine[v]);
                        if (!roomPush) {
                            let chamber: IChambre = { id: data.comparator.idchambre, isBookingBasic: false, img: data.comparator.img, isFumeur: data.comparator.isFumeur, maxoccup: data.comparator.maxoccup, surface: data.comparator.surface, lit: data.comparator.lit, groupcarac: data.comparator.groupcarac, isDeleted: false };
                            roomPush = new Room(chamber);
                            this.translate.translations[this.winRef.appConfigSite.defaultlangue]['chamber']["".concat(data.comparator.idchambre.toString(), '-titer')] = data.comparator.titre;
                            this.translate.translations[this.winRef.appConfigSite.defaultlangue]['chamber']["".concat(data.comparator.idchambre.toString(), '-description')] = data.comparator.description;
                            this.siteInfosService.addChamber(chamber)
                            this.rooms.push(roomPush);
                        }
                        if (!roomPush.lines.length) {// ajouter les ligneTarif
                            _map(rBasic.lines, (avaiLine) => {
                                let nl = new Line();
                                nl.bindingData(avaiLine);
                                roomPush.addLine(nl);
                            })
                        }
                        let t = key.split('_'), idLine = parseInt(t[1]), adult = t[2], child = t[3], index = t[4]
                            , _occupation = adult + "_" + child
                            //                                , indexSearch = _occupation + "_" + index
                            ;
                        let line = roomPush.findLineBy(idLine, _occupation);
                        //                        let line = roomPush.findLineByIndex(idLine, indexSearch); 
                        if (line) {
                            line.addEngine({ combine: newCombine, alias: data.comparator.engine }).enabled().updateMinEngine();
                            this.store.dispatch(new OtaAddCombine({ combine: newCombine, alias: data.comparator.engine }));
                        } else {
                            line = roomPush.findLine(idLine);
                            if (line) {
                                let lineClone = line.clone();
                                lineClone.clearEngine().setOccupation(_occupation).setIndexSearch(data.comparator.indexSearch);
                                lineClone.addEngine({ combine: newCombine, alias: data.comparator.engine }).enabled().updateMinEngine();
                                this.store.dispatch(new OtaAddCombine({ combine: newCombine, alias: data.comparator.engine }));
                                roomPush.addLine(lineClone);
                            } else {
                                log.error('id rate '.concat(idLine.toString(), ' not found in room ', roomPush.id.toString()))
                            }
                        }
                    })
                    if (!!keysRoom.length) {
                        this.orderByLine(this.adults, this.enfants)
                    }
                    this.store.dispatch(new OtaAddNew(ota));
                    //                    this.store.dispatch({type: 'OTA.add.new', payload: {ota: ota}});
                }
            }
        }
    }

    /**
     * add XHR ota
     */
    public addXhr(otaSubscription: Subscription): void {
        this.searchRun.push(otaSubscription);
    }

    /**
     * remove old XHR ota
     */
    public clearXhr(): void {
        this.searchRun.forEach(v => {
            v.unsubscribe();
        });
        this.searchRun.length = 0;
    }

    /**
     * search bestprice from  Ota (bokking,expedia,...)
     * @param alias string b,e,a...
     * @param ota Ota
     */
    private _bestPriceByOta(bestPrice: BestPrice, ota: Ota, currentAvailibility : Availibility): void {
        let minCombine = ota.getMinEngine();
        if (minCombine) {
            const [roomId] = minCombine.indexSearch.split('_');
            const currentAvailRoom = currentAvailibility.rooms.find((room: AvailRoom) => room.id == parseInt(roomId));
            if(currentAvailRoom && currentAvailRoom.stock == 0){
                const newMinCombine: ICombine = ota.getMinEngineWithoutRoom(parseInt(roomId));
                bestPrice.combine = newMinCombine;
            } else {
                bestPrice.combine = minCombine;
            }
        }
    }

    /**
     * @deprecated use priceManager
     * search bestprice from  Availibility
     */
    // private _bestPriceByAvailibility(rep: Availibility): void {
    //     let bestAvailLine = rep.getMinDisp();
    //     let bestPrice: BestPrice = find(this.bestRates, { alias: "w" });
    //     bestPrice.loading = false;
    //     if (bestAvailLine) {
    //         if (bestPrice) {
    //             bestPrice.combine = bestAvailLine.toCombine();
    //         }
    //     }
    // }

    /**
     * create list best Rates
     * @return Array<BestPrice>
     */
    private loadBestRates(): Array<BestPrice> {
        let result = [];
        _map(this.siteInfosService.getlistOtas(), (o, alias) => {
            if (!(this.winRef.appConfigSite.device == "PC" && alias == this.aliasBookingBasic)) {
                result.push(new BestPrice(o.name, alias));
            }
        });
        //result.push(new BestPrice("local", "w"));// is deprecated use priceManager
        return result;
    }

    /**
     * add bestRate Partner
     * @param aliasEngine 
     * @param rep 
     */
    private addBestRatePartner(aliasEngine: string, rep: Ota): void {
        if (aliasEngine == this.aliasBooking && !!rep.getEnginePartner()) {
            let partnerOffer: BestPrice = new BestPrice("partneroffer", "p")
            partnerOffer.combine = rep.getEnginePartner()
            partnerOffer.loading = false
            this.bestRates.push(partnerOffer);
        }
    }

    /**
     * add bestRate Partner
     * @param aliasEngine 
     * @param rep 
     */
    private addBestRateGoogle(aliasEngine: string, rep: Ota): void {
        if ((aliasEngine == this.aliasBooking || aliasEngine == this.aliasBackoffice) && !!rep.getMinEngineGoogleCache()) {
            let googleOffer: BestPrice = new BestPrice("google", "g")
            googleOffer.combine = rep.getMinEngineGoogleCache()
            googleOffer.loading = false
            this.bestRates.push(googleOffer);
        }
    }

    /**
     * search min Price (ttc) from expedia, booking...
     * @returns BestPrice|null
     */
    public getMinPrices(): BestPrice|null {
        const bestRates = this.getBestPrices();
        if (bestRates && bestRates.length) {
            return bestRates[0];
        }
        return null;
    }

    /**
     * getBestPrices
     */
    public getBestPrices() {
        const searchCriteria: SearchCriteria = {
            adults: this.adults,
            children: this.enfants
        };
        const bestRates: Array<BestPrice> = this.roomSortingService.sortBestRates(this.bestRates, searchCriteria)
        return bestRates;
    }
    /**
     * clear rooms
     */
    public clear(): void {
        this.rooms = this.siteInfosService.getChambre();
    }

    /**
     * first ota loading with data
     * @returns boolean
     */
    public getFirstLoadOta() {
        return this.firstLoadOta;
    }

    /**
     * Otas is all loading completed
     * @returns boolean
     */
    public getAllOtaLoaded() {
        return this.allOtaLoaded;
    }

    public setFirstLoadOta(isFirstLoadOta: boolean) {
        this.firstLoadOta = isFirstLoadOta;
    }

    public setAllOtaLoaded(allOtaLoaded: boolean) {
        this.allOtaLoaded = allOtaLoaded;
    }


    /**
     * formate errors comparators minStay & releaseDay
     */
    public getFormateErrorsComparator(errors: any): Array<any> {
        let errs = [];
        if (has(errors, 'minStay')) {
            errs.push({
                codemot: 'static.vousdevezreserverauminimum$x1nuitspourlaperiodeselectionnee',
                params: { val1: head(errors['minStay']) }
            });
        }
        //        if (has(errors, 'static.releaseDay')) {
        //            errs.push({
        //                codemot: 'releaseDay',
        //                params: {}
        //            });
        //        }
        return errs;
    }

    /**
     * get lastSearchDispo
     */
    public getLastSearchDispo(): SearchDispo {
        return this.lastSearchDispo;
    }

    /**
     * 
     */
    private eventBestPriceData() {
        let minPrice = this.getMinPrices(), response = { bestPrice: minPrice };
        if (minPrice) {
            this.translate.get('chamber.' + minPrice.combine['code_room'] + '-titer').subscribe((res: string) => {
                response['room'] = res;
                response['cpercente'] = this.winRef.appConfigSite.Cpercente;
            })
        }
        return response;
    }

    /**
     * getRoomsGroupByOccupationMin & order by price
     */
    public getRoomsGroupByOccupationMin(adults: number, childs: number): Array<Room> {
        return chain(this.rooms).map(r => {
            let lines = chain(r.lines).filter(l => {
                let engines = l.engines.filter((e: ICombineEngine) => {
                    const [adult, child] = e.combine.ocupation.split('_');
                    const diffAdults = parseInt(adult) - adults;
                    const diffChilds = parseInt(child) - childs;
                    return e.alias == this.aliasBooking
                        &&
                        (diffAdults >= 0 && (diffChilds + diffAdults) >= 0)
                });
                return engines.length > 0;
            }).value();
            if (lines.length > 0)
                return r;
        }).filter(r => !!r).sortBy(['orderTtc']).value();
    }

    /**
     * getBestRecommandation
     */
    public getBestRecommandation(recommendations: Array<Recommandations>): BestRecommandation {
        let bestRecommandation = [];
        _map(recommendations, (roomsRecommended: Recommandations) => {
            const items: Array<ItemRecommandation> = [];
            let price = 0;
            _map(roomsRecommended.rooms, (qte: number, key: string) => {
                const [idRoom, idLine] = key.split('_');
                const room: Room = find(this.rooms, { id: parseInt(idRoom) });
                const currentIndexSearch: string = key.concat('_', roomsRecommended.alias);
                // const line = room && room.findLineByIndex(parseInt(idLine), key.concat('_', roomsRecommended.alias));
                const line = room && room.findLineWithEngine(parseInt(idLine), currentIndexSearch);
                if (!!room && !!line) {

                    //fix bug (engineSelected.combine.indexSearch != currentIndexSearch) recommandation indexSearch
                    const engine: ICombineEngine = line.engines.find((e:ICombineEngine) => e.combine.indexSearch == currentIndexSearch);
                    const lineClone = line.clone();
                    const _occupation: string =  currentIndexSearch.split('_').slice(2, 4).join('_');
                    lineClone.clearEngine().setOccupation(_occupation).setIndexSearch(currentIndexSearch);
                    lineClone.addEngine(engine).enabled().updateMinEngine();
                    //end fix bug 

                    price += qte * lineClone.engineSelected.combine.detailPrice.Ttc;
                    let bedding = room.listBed[room.maxoccup];
                    let firstBed = first(bedding);
                    let keybedSelected: string;
                    let valbed: Array<any> = [];
                    if (firstBed) {
                        keybedSelected = firstBed.key;
                        valbed = firstBed.value;
                    }
                    items.push({ room: room, line: lineClone, qte: qte, bedding: bedding, keybedSelected: keybedSelected, valbed: valbed, adults: parseInt(line.occupation.split('_')[0]), child: parseInt(line.occupation.split('_')[1]) });
                } else {
                    console.log(`Errr ${key}, Room, Line avec l'index :${currentIndexSearch} n'exist pas`, !!room , !!line, room.lines.find(l => l.indexSearch == currentIndexSearch));
                }
            })
            !!items.length && bestRecommandation.push({
                price: price,
                roomsRecommended: roomsRecommended,
                items: items,
            });
        })
        if (bestRecommandation.length > 0) {
            return minBy(bestRecommandation, 'price');
        } else {
            return null;
        }

    }
}
